export default __webpack_public_path__ + "static/media/flag-timor-leste.70a7fb22.svg";